export default [
    {
        path: '/users',
        name: 'users',
        component: () => import('../../pages/users/IndexPage.vue'),
        meta: {
            title: 'Users',
            requiresAuth: true,
        },
    },
    {
        path: '/users/:id',
        name: 'users-detail',
        component: () => import('../../pages/users/IndexPage.vue'),
        meta: {
            title: 'User Detail',
            requiresAuth: true,
        },
    },
]
